import { useState } from "react";
import { mapToTimeZoneModel, SettingsModel, TimeZoneModel } from "../../models/settings-model";
import { UserService } from "../../services/UserService";
import { useSelector } from "react-redux";
import * as selector from '../../selectors/selectors'
import { SettingsService } from "../../services/SettingsService";
import { UtilityService } from "../../services/UtilityService";
import SettingsHeader from "./settingsHeader.component";
import CustomSwitch from "../shared/switch.component";
import BusinessHoursComponent from "./business-hours.component";
import { appNote } from "../shared/constants";

const AfterHours = () => {
    const Settings: SettingsModel = useSelector(selector.settingsObj)
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const [timeZone, setTimeZone] = useState<TimeZoneModel>(Settings?.Settings?.find(x => x.Code === SettingsService.Auto_Time_Zone_Code)?.Value?.toString().toLowerCase() === "true" ? UtilityService.getDefaultTimeZone() : (Settings && Settings?.Settings?.length > 0 && mapToTimeZoneModel(Settings?.Settings?.find(x => x.Code === SettingsService.Time_Zone_Code)?.Value?.toString() || "")) || UtilityService.getDefaultTimeZone())
    const [IsActive, setIsactive] = useState(false)
    const trimTimeZone = (time: any, chars: number) => {
        let label = `(${time.OffsetLabel}) ${time.Name}`
        return !!label ? label.slice(0, chars) + (label.length > chars ? "..." : "") : "";
    }

    const handleSwitch = (e) => {
        setIsactive(e)
    }

    return (
        <div className="h-p-100">
            <div className={`d-flex flex-direction w-p-100 ${IsMobileDevice ? "" : "py-2"} `}>
                <div className="d-flex justify-between w-p-100">
                    <SettingsHeader IsMobileDevice={IsMobileDevice} Title={"After Hours"} subTitle={"Select the times your business operates."} version={false} ShowTooltip={true} TooltipText={appNote.AFTER_HOURS} />
                    <div className={`d-flex ${IsMobileDevice ? 'flex-row-reverse box-shadow-display-background-shadow bb-primary-divider-4' : 'flex-direction'} w-p-50 `}>
                        <div className={`ml-auto d-flex ml-auto pr-2 my-auto`} style={{ gap: 20 }}>
                            <CustomSwitch
                                checked={IsActive}
                                onChange={(checked: boolean) => handleSwitch(checked)}
                            />
                        </div>
                        <div className={`${IsMobileDevice ? "h6-regular" : "h5-regular"} pr-2 ml-auto my-auto`}>
                            {trimTimeZone(timeZone, 30)}
                        </div>
                    </div>
                </div>
                {!IsMobileDevice && <div><hr className="unsubscribe-hr opacity-1 mt-1 mb-2 bg-color-disabled-btn"></hr></div>}
                <div className={`d-flex flex-direction ${IsMobileDevice ? ' w-p-95 mx-auto' : null}  `} style={{ gap: 10, }}>
                    <BusinessHoursComponent IsActive={IsActive} handleSwitch={handleSwitch} />
                </div>
            </div>
        </div>
    )
}

export default AfterHours